module.exports = __webpack_public_path__ + "static/media/logo_white.65e518a9.svg";